import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "../../styles/admin.css";

function useAdminNoIndex() {
  useEffect(() => {
    const existing = document.querySelector('meta[name="robots"]');
    const previous = existing?.getAttribute("content") ?? null;

    let meta = existing;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex, nofollow");

    return () => {
      if (!meta) {
        return;
      }
      if (previous) {
        meta.setAttribute("content", previous);
      } else {
        meta.remove();
      }
    };
  }, []);
}

export default function AdminLayout() {
  useAdminNoIndex();

  return (
    <div className="admin-shell">
      <Outlet />
    </div>
  );
}
